// @ts-check
import moment from "moment";

/**
 * @typedef {Object} StudyFileType
 * @property {number} POS
 * @property {string} INS_UID
 * @property {string} AE
 * @property {string} [PATH]
 */

/**
 * @typedef {Object} SeriesType
 * @property {number} SER_UID
 * @property {string} SER_ID
 * @property {string} MODALIDAD
 * @property {string} NOMBRE
 * @property {Array<StudyFileType>} FILES
 */

/**
 * @typedef {Object} StudyType
 * @property {number} ID
 * @property {string} FECHA
 * @property {string} NOMBRE
 * @property {string} SEXO
 * @property {string} PAS_ID
 * @property {string} PAS_BD
 * @property {string} EST_UID
 * @property {string} INFORM
 * @property {Array<SeriesType>} SERIES
 * @property {string} EDAD
 */

export default class Study {
  /**
   * @param {StudyType} data
   */
  constructor(data) {
    this.ID = data.ID;
    this.FECHA = data.FECHA;
    this.NOMBRE = data.NOMBRE;
    this.SEXO = data.SEXO;
    this.PAS_ID = data.PAS_ID;
    this.PAS_BD = data.PAS_BD;
    this.EST_UID = data.EST_UID;
    this.INFORM = data.INFORM;
    this.SERIES = data.SERIES;
    this.EDAD = data.EDAD;
  }
  getPatientName() {
    return this.NOMBRE.replaceAll("^", " ").trim();
  }
  getStudyDate() {
    return moment(this.FECHA, "YYYYMMDD").format("DD/MM/YYYY");
  }
}
